module.exports = __webpack_public_path__ + "img/2.ee5f1161.png";